
import { Split } from 'lucide-react';
import { TooltipIcon } from './TooltipIcon';
import { CarveOutsProps } from './types';

export const CarveOuts = ({ provider }: CarveOutsProps) => {
  const hasCarveOuts = 
    provider.allows_medical_carveout === true ||
    provider.allows_ancillary_carveout === true ||
    provider.allows_workers_comp_carveout === true ||
    provider.allows_epli_carveout === true ||
    provider.allows_401k_carveout === true;
    
  if (!hasCarveOuts) return null;
  
  return (
    <>
      <div className="absolute top-2 right-16">
        <TooltipIcon 
          icon={<Split className="h-4 w-4 text-amber-500" />} 
          tooltipText="Allows Carve-outs"
        />
      </div>
      
      <div className="mt-2 text-xs">
        <p className="font-medium mb-1">Carve-outs:</p>
        <div className="flex flex-wrap gap-2">
          {provider.allows_medical_carveout && (
            <span className="px-2 py-0.5 bg-blue-100 text-blue-800 rounded-full">Medical</span>
          )}
          {provider.allows_ancillary_carveout && (
            <span className="px-2 py-0.5 bg-green-100 text-green-800 rounded-full">Ancillary</span>
          )}
          {provider.allows_workers_comp_carveout && (
            <span className="px-2 py-0.5 bg-amber-100 text-amber-800 rounded-full">Workers Comp</span>
          )}
          {provider.allows_epli_carveout && (
            <span className="px-2 py-0.5 bg-purple-100 text-purple-800 rounded-full">EPLI</span>
          )}
          {provider.allows_401k_carveout && (
            <span className="px-2 py-0.5 bg-teal-100 text-teal-800 rounded-full">401(k)</span>
          )}
        </div>
      </div>
    </>
  );
};
